import { render, staticRenderFns } from "./151.vue?vue&type=template&id=38bdb824&scoped=true&"
import script from "./151.vue?vue&type=script&lang=js&"
export * from "./151.vue?vue&type=script&lang=js&"
import style0 from "./151.vue?vue&type=style&index=0&id=38bdb824&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bdb824",
  null
  
)

export default component.exports